import "../styles/fonts.css";
import "../../../shared/app.css";
import "../styles/web-compat.css";
import "./styles.css";
import "../../../shared/ink.js";
import "../../../shared/motion.js";
import "../../../shared/feedkeys.js";
import { StrictMode, useEffect, useState, type ComponentType } from "react";
import { createRoot } from "react-dom/client";
import emojiRange from "../../../shared/fonts/echo-emoji.range?raw";
import emojiFontUrl from "../../../shared/fonts/echo-emoji.woff2?url";
import { createStartupLoader, initializeApplication } from "./lib/bootstrap";
import { Runtime } from "../store/runtime";
import * as sounds from "../lib/sounds";
import { swap } from "./lib/transition";

const runtime = new Runtime({ transition: swap });
runtime.onRing = (start) => (start ? sounds.ringStart() : sounds.ringStop());
if (import.meta.env.DEV) (window as unknown as { __rt: Runtime }).__rt = runtime;
if (!document.getElementById("echo-emoji-face")) {
  const face = document.createElement("style");
  face.id = "echo-emoji-face";
  face.textContent = `@font-face{font-family:"Echo Emoji";src:url(${JSON.stringify(emojiFontUrl)}) format("woff2");font-display:block;unicode-range:${emojiRange.trim()}}`;
  document.head.appendChild(face);
}
const startup = createStartupLoader(
  async () => {
    await initializeApplication();
    return (await import("./app")).App;
  },
  () => {
    runtime.start();
    runtime.resume();
  },
);
function Startup() {
  const [App, setApp] = useState<ComponentType<{ rt: Runtime }> | null>(null);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let live = true;
    void startup.load().then(
      (component) => {
        if (live) setApp(() => component);
      },
      () => {
        if (live) setError(true);
      },
    );
    return () => {
      live = false;
    };
  }, [attempt]);
  if (App) return <App rt={runtime} />;
  const ru = navigator.language.startsWith("ru");
  return (
    <div className="window">
      <div className="login">
        <div className="login__card echo-material-thick">
          <div className="login__title">EchoFloat</div>
          <p role={error ? "alert" : "status"}>
            {error
              ? ru
                ? "Не удалось загрузить приложение. Проверьте соединение и повторите попытку."
                : "Unable to load the application. Check your connection and try again."
              : ru
                ? "Загрузка…"
                : "Loading…"}
          </p>
          {error && (
            <button
              type="button"
              className="echo-button echo-button--prominent"
              onClick={() => {
                setError(false);
                setAttempt((n) => n + 1);
              }}
            >
              {ru ? "Повторить" : "Retry"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
const element = document.getElementById("main");
if (!element) throw new Error("index.html lost its #main");
const root = createRoot(element);
root.render(
  <StrictMode>
    <Startup />
  </StrictMode>,
);
import.meta.hot?.dispose(() => {
  startup.cancel();
  root.unmount();
  runtime.dispose();
});
